import { useState, useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import "./AssignTrainer.css";
import { getMembers } from "../../services/memberService";
import {
  getTrainers,
  assignMemberToTrainer,
} from "../../services/trainerService";
import { FaDumbbell } from "react-icons/fa";

export default function AssignTrainer() {
  const [members, setMembers] = useState([]);
  const [trainers, setTrainers] = useState([]);

  const [memberId, setMemberId] = useState("");
  const [trainerId, setTrainerId] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const memberData = await getMembers();
    const trainerData = await getTrainers();

    setMembers(memberData);
    setTrainers(trainerData);
  };

  const handleAssign = async () => {
    try {
      if (!memberId || !trainerId) {
        alert("Please select member and trainer");
        return;
      }

      const selectedTrainer = trainers.find(
        (trainer) => trainer.id === trainerId,
      );

      await assignMemberToTrainer(trainerId, memberId, selectedTrainer.name);

      alert("Trainer Assigned Successfully");
    } catch (error) {
      console.error(error);
      alert("Error assigning trainer");
    }
  };

  return (
    <DashboardLayout>
      <div className="assign-page">
        <div className="assign-header">
          <div>
            <h1>Assign Trainer</h1>
            <p style={{ fontWeight: "bold", color: "white" }}>
              Assign gym members to trainers and manage coaching relationships.
            </p>
          </div>
        </div>

        <div className="assign-card">
          <div className="assign-icon">
            <FaDumbbell />
          </div>

          <h2>Trainer Assignment</h2>

          <p className="assign-subtitle">
            Select a member and trainer to create an assignment.
          </p>

          <div className="form-group">
            <label>Member</label>

            <select
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
            >
              <option value="">Choose Member</option>

              {members.map((member) => (
                <option key={member.id} value={member.id}>
                  {member.fullName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Trainer</label>

            <select
              value={trainerId}
              onChange={(e) => setTrainerId(e.target.value)}
            >
              <option value="">Choose Trainer</option>

              {trainers.map((trainer) => (
                <option key={trainer.id} value={trainer.id}>
                  {trainer.name}
                </option>
              ))}
            </select>
          </div>

          <button className="assign-btn" onClick={handleAssign}>
            Assign Trainer
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
